<template>
  <section class="troubleshoot-software">
    <h3>
      <span @click="$emit('back')">
        Troubleshoot
      </span>

      {{ activeCategory }}
    </h3>

    <div class="flex-wrapper">
      <div class="side-nav">
        <troubleshoot-menu
          :menu-content="menuList.map(i => i.title)"
          v-model="content"
          @input="$emit('input', content)"
        >
        </troubleshoot-menu>
      </div>

      <div class="content-wrapper">
        <h2>
          {{ menuList[content].title }}
        </h2>

        <div
          class="content"
          v-for="(item, index) in menuList[content].content"
          :key="index"
        >
          <p v-if="item.subtitle">
            {{ item.subtitle }}
          </p>

          <ul>
            <li v-for="(instruction, index) in item.instructions" :key="index">
              {{ instruction }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import TroubleshootMenu from "@/components/troubleshoot/TroubleshootMenu.vue";

export default {
  props: ["activeCategory", "activeContent", "menuList"],

  watch: {
    activeContent(val) {
      this.content = val;
    }
  },

  data() {
    return {
      content: this.activeContent
    };
  },

  components: {
    TroubleshootMenu
  }
};
</script>

<style lang="scss" scoped>
.troubleshoot-software {
  z-index: 2;
  width: 100%;

  h3 {
    margin-bottom: 40px;
    font-weight: 400;
    color: #6e6e6e;
    display: flex;
    align-items: center;
    text-transform: capitalize;

    @include mobile {
      justify-content: center;
      font-size: 16px;
      margin-bottom: 20px;
    }

    span {
      cursor: pointer;
      display: flex;
      align-items: center;

      &:hover {
        text-decoration: underline;
      }

      &:after {
        content: "";
        display: inline-block;
        pointer-events: none;
        border: 2px solid;
        border-color: #6e6e6e #6e6e6e transparent transparent;
        width: 4px;
        height: 4px;
        transform: rotateZ(45deg);
        margin-right: 15px;
        margin-left: 10px;
      }
    }
  }

  .flex-wrapper {
    display: flex;

    @include mobile {
      flex-direction: column;
    }
  }

  .troubleshoot-menu {
    width: 300px;

    @include mobile {
      width: 100%;
    }
  }

  .content-wrapper {
    flex: 1 1 auto;
    background-color: #fff;
    border-radius: 5px;
    border: 1px solid #cbd6d6;
    overflow: hidden;
    margin-left: 20px;
    padding: 20px;

    @include mobile {
      margin-left: 0;
      margin-top: 20px;
    }

    h2 {
      color: #4ccbb9;
      font-size: 24px;
      font-family: $Quicksand;

      @include mobile {
        font-size: 16px;
      }
    }

    .content {
      margin-top: 10px;
      color: #6e6e6e;

      p {
        padding: 5px 0;
        font-weight: 600;
      }

      ul {
        list-style-type: decimal;
        list-style-position: outside;
        margin-left: 15px;
        margin-bottom: 10px;

        li {
          font-size: 14px;
          line-height: 24px;

          @include mobile {
            font-size: 12px;
            line-height: 20px;
          }
        }
      }
    }
  }
}
</style>
